import { useTranslation } from "react-i18next";
import { getImage } from "../../services/ImageService";
import { LanguageSelectionButton } from "../LanguageSelectionButton/LanguageSelectionButton";

export function LanguageSelection(props) {
    const { t, i18n } = useTranslation();

    function changeLanguage(language) {
        i18n.changeLanguage(language);
        localStorage.setItem("selectedLanguage", language);
    }

    return (
        <div
            className={`relative group flex items-center w-max items-center cursor-pointer select-none h-full ${
                props.className ? props.className : ""
            }`}
        >
            <div className="z-20 text-base font-bold text-pine h-full w-full flex items-center gap-3 h-[50px] rounded-full group-hover:bg-[rgba(36,45,41,0.05)] md:px-12">
                {t(i18n.resolvedLanguage)}
                <div className="w-4 mt-1">
                    <img
                        src={getImage("gui/menu-down-pine.svg")}
                        className="w-full"
                    />
                </div>
            </div>
            <div className="hidden group-hover:flex absolute flex-col bg-white z-10 w-max top-32 right-0 left-auto select-none overflow-y-auto shadow-2xl rounded-3xl">
                <LanguageSelectionButton
                    content={t("english")}
                    onClick={() => changeLanguage("en")}
                />
                <LanguageSelectionButton
                    content={t("swedish")}
                    onClick={() => {
                        changeLanguage("sv");
                    }}
                />
            </div>
        </div>
    );
}
